import { render, staticRenderFns } from "./error-message.vue?vue&type=template&id=02b304aa&scoped=true"
import script from "./error-message.vue?vue&type=script&lang=ts&setup=true"
export * from "./error-message.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./error-message.vue?vue&type=style&index=0&id=02b304aa&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b304aa",
  null
  
)

export default component.exports